<template>
  <section class="community-section" ref="section">
    <!-- 배경 이미지 -->
    <div class="bg-images">
      <div
        class="bg-image"
        v-for="(item, index) in communities"
        :key="index"
        :class="{ active: activeCommunity === index && introComplete }"
      >
        <img :src="item.image" :alt="item.name" />
        <div class="bg-overlay"></div>
      </div>
    </div>

    <!-- 우측하단 워터마크 -->
    <img src="@/assets/logo/logo_symbol.png" alt="" class="watermark-logo" />

    <!-- COMMUNITY 타이틀 (중앙에서 위로 이동) -->
    <div class="top-title" :class="{ collapsed: titleCollapsed, 'move-up': titleMovedUp }">
      <span v-for="(letter, i) in 'COMMUNITY'.split('')" :key="i" class="letter">{{ letter }}</span>
    </div>

    <!-- 메인 콘텐츠 -->
    <div class="content-wrapper" :class="{ visible: introComplete }">
      <!-- 상단: 타이틀 -->
      <div class="title-area">
        <span class="sub-title">TECHNO RAYONE CITY</span>
        <h2 class="main-title">커뮤니티 시설</h2>
        <p class="main-desc">입주민의 일상을 더욱 풍요롭게</p>
      </div>

      <!-- 중앙: 원형 시설 카드들 -->
      <div class="facility-nav">
        <div
          class="facility-item"
          v-for="(item, index) in communities"
          :key="index"
          :class="{ active: activeCommunity === index }"
          @click="setActiveCommunity(index)"
        >
          <div class="facility-image">
            <img :src="item.thumb" :alt="item.name" />
            <div class="facility-overlay"></div>
          </div>
          <span class="facility-label">{{ item.name }}</span>
        </div>
      </div>

      <!-- 하단: 선택된 시설 이름 -->
      <transition name="fade-up" mode="out-in">
        <div class="facility-name" :key="activeCommunity">
          <span class="name-eng">{{ communities[activeCommunity].eng }}</span>
          <h3>{{ communities[activeCommunity].name }}</h3>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CommunitySection',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeCommunity: 0,
      isScrollLocked: false,
      titleCollapsed: false,
      titleMovedUp: false,
      introComplete: false,
      introShown: false,
      communities: [
        {
          name: 'YBM영어마을',
          eng: 'YBM English Village',
          thumb: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=400&q=80',
          image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=1920&q=80'
        },
        {
          name: '조식&중식서비스',
          eng: 'Meal Service',
          thumb: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=400&q=80',
          image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1920&q=80'
        },
        {
          name: '스크린골프 연습장',
          eng: 'Screen Golf',
          thumb: 'https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=400&q=80',
          image: 'https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=1920&q=80'
        },
        {
          name: '물놀이 시설',
          eng: 'Water Play',
          thumb: 'https://images.unsplash.com/photo-1505118380757-91f5f5632de0?w=400&q=80',
          image: 'https://images.unsplash.com/photo-1505118380757-91f5f5632de0?w=1920&q=80'
        },
        {
          name: '패밀리 캠핑장',
          eng: 'Family Camping',
          thumb: 'https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=400&q=80',
          image: 'https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=1920&q=80'
        },
        {
          name: '영화 감상실',
          eng: 'Cinema Room',
          thumb: 'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=400&q=80',
          image: 'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=1920&q=80'
        },
        {
          name: '황톳길 산책로',
          eng: 'Loess Trail',
          thumb: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400&q=80',
          image: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1920&q=80'
        },
        {
          name: '카페',
          eng: 'Café',
          thumb: 'https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?w=400&q=80',
          image: 'https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?w=1920&q=80'
        }
      ]
    }
  },
  watch: {
    isActive(newVal) {
      if (newVal && !this.introShown) {
        this.startIntroAnimation()
      }
    }
  },
  methods: {
    startIntroAnimation() {
      this.isScrollLocked = true
      // 0.5초 후 글자 모으기
      setTimeout(() => {
        this.titleCollapsed = true
      }, 500)
      // 1초 후 위로 이동 시작
      setTimeout(() => {
        this.titleMovedUp = true
      }, 1000)
      // 2.8초 후 인트로 완료 (이동 애니메이션 1.8s 고려)
      setTimeout(() => {
        this.introComplete = true
        this.introShown = true
        this.isScrollLocked = false
      }, 2800)
    },
    setActiveCommunity(index) {
      if (this.isScrollLocked || !this.introComplete) return
      this.activeCommunity = index
    },
    handleScroll(direction) {
      if (this.isScrollLocked) return
      if (!this.introComplete) return

      if (direction === 'down') {
        if (this.activeCommunity < this.communities.length - 1) {
          this.isScrollLocked = true
          this.activeCommunity++
          setTimeout(() => {
            this.isScrollLocked = false
          }, 800)
        } else {
          this.$emit('next-section')
        }
      } else if (direction === 'up') {
        if (this.activeCommunity > 0) {
          this.isScrollLocked = true
          this.activeCommunity--
          setTimeout(() => {
            this.isScrollLocked = false
          }, 800)
        } else {
          this.$emit('prev-section')
        }
      }
    }
  }
}
</script>

<style scoped>
.community-section {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: #111;
}

/* 배경 이미지 */
.bg-images {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 1.2s ease;
}

.bg-image.active {
  opacity: 1;
}

.bg-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(0, 0, 0, 0.6) 50%,
    rgba(0, 0, 0, 0.75) 100%
  );
}

/* 워터마크 */
.watermark-logo {
  position: absolute;
  bottom: -15%;
  right: -10%;
  width: 900px;
  height: auto;
  opacity: 0.1;
  pointer-events: none;
  z-index: 1;
  filter: brightness(0) invert(1);
}

/* COMMUNITY 타이틀 (중앙에서 위로 이동) */
.top-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  display: flex;
  justify-content: center;
  white-space: nowrap;
  transition: top 1.8s cubic-bezier(0.22, 1, 0.36, 1), transform 1.8s cubic-bezier(0.22, 1, 0.36, 1);
}

.top-title.move-up {
  top: 12%;
  transform: translate(-50%, 0);
}

.top-title .letter {
  font-family: var(--font-serif);
  font-size: 140px;
  font-weight: 400;
  font-style: italic;
  color: transparent;
  -webkit-text-stroke: 2px rgba(255, 255, 255, 0.7);
  transition: margin 1s cubic-bezier(0.16, 1, 0.3, 1), font-size 1s cubic-bezier(0.16, 1, 0.3, 1);
  margin: 0 24px;
  display: inline-block;
  text-shadow: 0 0 30px rgba(255, 255, 255, 0.2);
}

.top-title.collapsed .letter {
  margin: 0 3px;
}

.top-title.move-up .letter {
  font-size: 100px;
}

/* 콘텐츠 */
.content-wrapper {
  position: relative;
  z-index: 10;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: 60px 60px 80px;
  text-align: center;
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.content-wrapper.visible {
  opacity: 1;
  transform: translateY(0);
}

/* 타이틀 영역 */
.title-area {
  margin-bottom: 50px;
  background: radial-gradient(ellipse at center, rgba(0, 0, 0, 0.4) 0%, transparent 70%);
  padding: 30px 60px;
  border-radius: 20px;
}

.sub-title {
  font-family: var(--font-paperlogy);
  font-size: 14px;
  font-weight: 700;
  color: #7a9bb5;
  letter-spacing: 5px;
  margin-bottom: 20px;
  display: block;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

.main-title {
  font-family: var(--font-paperlogy);
  font-size: 48px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 6px;
  margin-bottom: 16px;
  text-shadow: 0 2px 20px rgba(0, 0, 0, 0.5);
}

.main-desc {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 3px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

/* 시설 네비게이션 - 원형 */
.facility-nav {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 50px;
}

.facility-item {
  cursor: pointer;
  transition: all 0.4s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.facility-image {
  width: 110px;
  height: 110px;
  overflow: hidden;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  position: relative;
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
  filter: grayscale(100%);
}

.facility-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  transition: all 0.4s ease;
  border-radius: 50%;
}

.facility-item.active .facility-image {
  width: 130px;
  height: 130px;
  border-color: var(--rayone-primary);
  border-width: 4px;
  filter: grayscale(0%);
  box-shadow: 0 0 40px rgba(163, 32, 53, 0.5);
}

.facility-item.active .facility-overlay {
  background: transparent;
}

.facility-item:hover:not(.active) .facility-image {
  border-color: rgba(255, 255, 255, 0.6);
  filter: grayscale(50%);
}

.facility-item:hover:not(.active) .facility-overlay {
  background: rgba(0, 0, 0, 0.2);
}

.facility-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.facility-label {
  font-family: var(--font-paperlogy);
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 1px;
  transition: all 0.3s ease;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
}

.facility-item.active .facility-label {
  color: #fff;
  font-weight: 700;
  font-size: 15px;
}

/* 시설 이름 */
.facility-name {
  min-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.name-eng {
  font-family: var(--font-serif);
  font-size: 18px;
  font-style: italic;
  color: #7a9bb5;
  letter-spacing: 4px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

.facility-name h3 {
  font-family: var(--font-paperlogy);
  font-size: 42px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 8px;
  position: relative;
  display: inline-block;
  text-shadow: 0 2px 20px rgba(0, 0, 0, 0.5);
}

.facility-name h3::before,
.facility-name h3::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 80px;
  height: 1px;
  background: linear-gradient(to var(--dir), transparent, rgba(232, 160, 170, 0.5));
}

.facility-name h3::before {
  --dir: right;
  right: calc(100% + 30px);
}

.facility-name h3::after {
  --dir: left;
  left: calc(100% + 30px);
}

/* 트랜지션 */
.fade-up-enter-active {
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

.fade-up-leave-active {
  transition: all 0.3s ease;
}

.fade-up-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.fade-up-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
